import React, { useState, useEffect } from 'react';
import { RiCloseFill } from "react-icons/ri";
import './entries.css'
import CustomSelect from '../capture/custom-select';

const LocationsModal = ({ master, onClose }) => {
    const [rows, setRows] = useState([]);
    const [totalsMatch, setTotalsMatch] = useState(false);
    const [isClosing, setIsClosing] = useState(false);  // para animacion cuando se cierre el modal

    const handleAddRow = () => {
        setRows(prev => [
        ...prev,
        {
            id: prev.length + 1,
            pzas: '',
            peso: '',
            locacion: ''
        }
        ]);
    };

    const handleDeleteRow = (id) => {
        setRows(prev => prev.filter(row => row.id !== id).map((row, i) => ({ ...row, id: i + 1 })));
    };

    const handleInputChange = (id, field, value) => {
        const numericValue = parseFloat(value);
        if (numericValue < 0) return; // No actualiza si es negativo

        setRows(prev =>
            prev.map(row =>
                row.id === id ? { ...row, [field]: value } : row
            )
        );
    };

    useEffect(() => {
        let totalPzas = 0;
        let totalPeso = 0;
    
        for (let i = 0; i < rows.length; i++) {  // ciclo for que se repetira dependiendo cuantas filas haya
            const row = rows[i];  // asiganmos los valores de la fila actual a "row"
        
            if (row.pzas) {   // si hay un valor en "piezas" de esa fila actual
                totalPzas += parseFloat(row.pzas);  // va a sumarse al valor anterior que ya haya
            }
        
            if (row.peso) {  // si hay un valor en "peso" de esa fila actual
                totalPeso += parseFloat(row.peso);  // va a sumarse al valor anterior que ya haya
            }
        }
    
        if (totalPzas === parseFloat(master.pzas) && totalPeso === parseFloat(master.weight)) {  // si el numero total de piezascy peso (que son las sumas que hice en el for) es igual al valor que traiga master.pzas y master.weight
            setTotalsMatch(true);  // Manda un valor de true a totalsMatch para que ya no muestre la alerta roja
            } else {
            setTotalsMatch(false);  // si no, va a seguir mostrando la alerta roja
        }
    }, [rows, master.pzas, master.weight]);

    const locacionesOptions = ['Locación A', 'Locación B', 'Locación C'];
    const consigners = [{id: 1, code: "111", name: "Consigner 1"}, {id: 2, code: "222", name: "Consignatario 2"}, {id: 3, code: "333", name: "Consigner test 3"} ];

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
          onClose();
        }, 300); // mismo tiempo que la animación (0.3s)
    };

    return (
        <div className="modal show d-block" tabIndex="-1"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                zIndex: 1050
            }}
        >
            {/* Fondo oscuro */}
            <div
                style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 1040
                }}
            />
            <div className={`modal-dialog modal-lg ${isClosing ? 'modal-slide-up' : 'modal-slide-down'}`}
                style={{
                    position: 'relative',
                    zIndex: 1060,
                    margin: '5vh auto'
                }}
            >
                <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: '#020C41', color: 'white', padding: '0.5rem 1rem' }}>
                        <h5 className="modal-title m-0">Bultos y Locaciones</h5>
                        <button type="button" className="btn-close btn-close-white" onClick={handleClose}></button>
                    </div>

                    <div className="modal-body container-fluid">
                        <div className="row text-center mt-4 mb-3">
                            <div className="col-6"><strong>Piezas:</strong> {master.pzas}</div>
                            <div className="col-6"><strong>Peso:</strong> {master.weight}</div>
                        </div>
                        <table className="table mt-4">

                            <thead className="text-center">
                                <tr>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Bultos</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Pzas</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Peso</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Locación</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}></th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                {rows.map((row) => (
                                    <tr key={row.id}>
                                        <td>{row.id}</td>
                                        <td>
                                            <input
                                                type="number"
                                                value={row.pzas}
                                                onChange={(e) => handleInputChange(row.id, 'pzas', e.target.value)}
                                                className="form-control form-control-sm"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                value={row.peso}
                                                onChange={(e) => handleInputChange(row.id, 'peso', e.target.value)}
                                                className="form-control form-control-sm"
                                            />
                                        </td>
                                        <td>
                                            {/* <select
                                                value={row.locacion}
                                                onChange={(e) => handleInputChange(row.id, 'locacion', e.target.value)}
                                                className="form-select"
                                            >
                                                <option value="">Selecciona</option>
                                                {locacionesOptions.map((opt, idx) => (
                                                <option key={idx} value={opt}>{opt}</option>
                                                ))}
                                            </select> */}
                                            <CustomSelect label="" options={consigners} labelKey="name" />
                                        </td>
                                        <td>
                                            <button className="btn" onClick={() => handleDeleteRow(row.id)}>
                                                <RiCloseFill />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="text-center">
                            <button className='btnn' style={{fontSize: '26px', padding: '0px 20px'}} onClick={handleAddRow}>+</button>
                        </div>

                        {!totalsMatch ? (
                            <div className="alert alert-danger text-center mt-3" role="alert">
                                <strong>Error!</strong> El peso/piezas total no coincide con los de la master. Favor de revisar.
                            </div>
                        ) : (
                            <div className="text-center d-flex justify-content-end mt-3">
                                <button className="btnn" onClick={() => alert('Datos validados y aceptados')}>
                                    Aceptar
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LocationsModal;